export default function() {
    return function({ e, addVariant }) {
        addVariant('oprema', 'body[data-theme="oprema"] &')
    };
};
